<template>
  <v-card>
    <v-container style="max-width: 1500px">
      <v-row>
        <v-col cols="12">
          <v-toolbar color="secondary" flat dense>
            <v-toolbar-title>Sales Reports</v-toolbar-title>
          </v-toolbar>
        </v-col>
      </v-row>

      <!-- column two -->
      <v-row class="shortcuts-padding">
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row dense>
            <v-col cols="12" md="4">
              <v-btn v-if="userLoaded && !AmayaVersion"  to="/sales-invoices-report" text left><v-icon left>mdi-list-box-outline</v-icon> Sale Invoices
                Report</v-btn><br />
                
              <v-btn to="/sold-products-report" text left><v-icon left>mdi-list-box-outline</v-icon> Sold
                Products Report</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion"  to="/sold-products-summary-report" text left><v-icon left>mdi-list-box-outline</v-icon>Summarized
                Sold Products Report</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/grouped-by-date-sales-report" text left><v-icon left>mdi-list-box-outline</v-icon> Grouped By
                Date Sales Report</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/branch-sales-report" text left><v-icon left>mdi-list-box-outline</v-icon> Branch Sales
                Report</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/outsourced-sales-report" text left><v-icon left>mdi-list-box-outline</v-icon> Outsourced Sales
                Report</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/sales-return-report" text left><v-icon left>mdi-list-box-outline</v-icon> Sales Return
                Report</v-btn><br />

              <v-btn v-if="userLoaded && HideProfitReports != true && !AmayaVersion" to="/profit-margin-report" text left><v-icon
                  left>mdi-list-box-outline</v-icon>
                Profit Margin Report</v-btn><br />

              <v-btn v-if="userLoaded && HideProfitReports != true && !AmayaVersion" to="/combined-profit-report" text left><v-icon
                  left>mdi-chart-multiple</v-icon>
                Combined Profit Report</v-btn><br />

            </v-col>

            <v-col cols="12" md="4" v-if="userLoaded && !AmayaVersion">
              <v-btn to="/combined-sales-by-brand" text left><v-icon left>mdi-list-box-outline</v-icon> Combined Sales
                Report</v-btn><br />

                   <v-btn v-if="userLoaded && !AmayaVersion" to="/combined-sold-products-report" text left><v-icon left>mdi-list-box-outline</v-icon> Combined Sold Products
                Report</v-btn><br />

              <v-btn to="/employees-performance-report" text left><v-icon left>mdi-list-box-outline</v-icon>Employees
                Performance Report</v-btn><br />

              <v-btn to="/brands-performance-report" text left><v-icon left>mdi-list-box-outline</v-icon> Brands
                Performance Analysis</v-btn><br />

            </v-col>

          </v-row>
        </v-col>

      </v-row>

      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </v-card>
</template>


<script>
export default {
  components: {},
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
  },
  data() {
    return {
      loader: false,
      loading: false,
      HideProfitReports: false,
      AmayaVersion: true,
      userLoaded: false,
    };
  },
  methods: {
    getUser() {
      const self = this;
      var user_id = localStorage.getItem("userId");
      this.loader = true;
      this.$store
        .dispatch("get", `/users/${user_id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            this.HideProfitReports = res.ResponseData.HideProfitReports == "Y" ? true : false;
            this.AmayaVersion = res.ResponseData.AmayaVersion == "Y" ? true : false;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          this.userLoaded = true;
        })
        .catch((err) => {
          this.userLoaded = true;
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getUser();
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.cardText {
  font-weight: bold;
  font-size: 18px;
  padding: 12px;
  color: #757575;
}

.dash-btn {
  margin-top: -5px;
}
</style>